module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/artillery-strike-elite-toolbar.556f09ef.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/artillery-strike-elite-toolbar.png
// module id = 3700
// module chunks = 11